import { Table } from "@phosphor-icons/react";

const formatCurrency = (value) => {
  return `₹${value.toLocaleString('en-IN')}`;
};

export const YearlyBreakdownTable = ({ data }) => {
  return (
    <div className="bg-white rounded-sm border border-slate-200 p-6 lg:p-8" data-testid="breakdown-table">
      <div className="flex items-center gap-3 mb-6 pb-6 border-b border-slate-200">
        <Table size={24} weight="duotone" className="text-emerald-700" />
        <div>
          <h2 className="text-xl font-semibold tracking-tight text-slate-900">Year-wise Breakdown</h2>
          <p className="text-sm text-slate-500 mt-0.5">Detailed annual projection data</p>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-slate-200">
              <th className="text-left py-3 px-4 text-xs uppercase tracking-[0.2em] font-medium text-slate-500">
                Year
              </th>
              <th className="text-right py-3 px-4 text-xs uppercase tracking-[0.2em] font-medium text-slate-500">
                Starting AUM
              </th>
              <th className="text-right py-3 px-4 text-xs uppercase tracking-[0.2em] font-medium text-slate-500">
                SIP Inflow
              </th>
              <th className="text-right py-3 px-4 text-xs uppercase tracking-[0.2em] font-medium text-slate-500">
                Lumpsum
              </th>
              <th className="text-right py-3 px-4 text-xs uppercase tracking-[0.2em] font-medium text-slate-500">
                Redemption
              </th>
              <th className="text-right py-3 px-4 text-xs uppercase tracking-[0.2em] font-medium text-slate-500">
                Growth
              </th>
              <th className="text-right py-3 px-4 text-xs uppercase tracking-[0.2em] font-medium text-slate-500">
                Ending AUM
              </th>
              <th className="text-right py-3 px-4 text-xs uppercase tracking-[0.2em] font-medium text-slate-500">
                Trail Revenue
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr 
                key={row.year} 
                className="border-b border-slate-100 hover:bg-slate-50 transition-colors duration-150"
                data-testid={`table-row-year-${row.year}`}
              >
                <td className="py-3 px-4 font-mono text-sm font-semibold text-slate-900">
                  {row.year}
                </td>
                <td className="py-3 px-4 font-mono text-sm text-slate-700 text-right">
                  {formatCurrency(row.starting_aum)}
                </td>
                <td className="py-3 px-4 font-mono text-sm text-slate-700 text-right">
                  {formatCurrency(row.sip_inflow)}
                </td>
                <td className="py-3 px-4 font-mono text-sm text-slate-700 text-right">
                  {formatCurrency(row.lumpsum_inflow)}
                </td>
                <td className="py-3 px-4 font-mono text-sm text-red-600 text-right">
                  -{formatCurrency(row.redemption)}
                </td>
                <td className="py-3 px-4 font-mono text-sm text-emerald-600 text-right">
                  +{formatCurrency(row.market_growth)}
                </td>
                <td className="py-3 px-4 font-mono text-sm font-semibold text-slate-900 text-right">
                  {formatCurrency(row.ending_aum)}
                </td>
                <td className="py-3 px-4 font-mono text-sm font-semibold text-emerald-700 text-right">
                  {formatCurrency(row.trail_revenue)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-6 pt-6 border-t border-slate-200">
        <div className="flex flex-wrap gap-4 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-emerald-600"></div>
            <span className="text-slate-600">Positive Growth</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-red-600"></div>
            <span className="text-slate-600">Redemptions</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YearlyBreakdownTable;